import { httpService } from '../services/httpService';

export interface ViaCepResponse {
  cep?: string;
  logradouro?: string;
  complemento?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  ibge?: string;
  gia?: string;
  ddd?: string;
  siafi?: string;
  erro?: boolean;
}

export function useViaCep() {
  const lookupCep = async (cep: string): Promise<ViaCepResponse> => {
    const cleaned = cep.replace(/\D/g, '');

    if (cleaned.length !== 8) {
      return { erro: true };
    }

    try {
      // External ViaCEP API — no PHP contract applies
      const data = await httpService.get<ViaCepResponse>(`https://viacep.com.br/ws/${cleaned}/json/`);

      if (data.erro) {
        return { erro: true };
      }

      return data;
    } catch {
      return { erro: true };
    }
  };

  return { lookupCep };
}
